import template from './daily_balance_sheet_report_print.html';
import controller from './daily_balance_sheet_report_print.controller';
import './daily_balance_sheet_report_print.scss';

let DailyBalanceSheetReportPrintComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default DailyBalanceSheetReportPrintComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/daily_balance_sheet/print/daily_balance_sheet_report/daily_balance_sheet_report_print.component.js